import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './kicker.css';
import '../chip/chip.js';

/**
 * Renders a kicker label: plain text by default, or as a chip when a variant is set.
 * @property {string} text - The kicker/label text
 * @property {ChipVariant | ''} variant - When set, renders as a chip with this variant; empty renders plain text
 */
export default class Kicker extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            text: '',
            variant: '',
        };
    }

    template() {
        if (!this.text) return html``;

        return this.variant
            ? html`<mb-chip
                  variant="${this.variant}"
                  text="${this.text}"
                  class="mb-chip-size-md md:mb-chip-size-lg"
              ></mb-chip>`
            : html`<span>${this.text}</span>`;
    }
}

defineElement('mb-kicker', Kicker);
